<template>
	<div class="toolbar-abstract">
        <div class="outer">
            <slot></slot>
        </div>
	</div>
</template>

<script>
export default {
    name: 'ToolbarAbstract'
}
</script>

<style scoped>
.toolbar-abstract {
    width: 100%;
    height: 100%;
    display: grid;
    overflow-y: auto;
    user-select: none;
}

.toolbar-abstract .outer {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
}

@media (max-width: 600px) {
    .toolbar-abstract .outer {
        flex-direction: row;
    }
}
</style>